var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ui-heading',{attrs:{"tag":"h5"}},[_vm._v(" "+_vm._s(_vm.$t("companyProcedures.comment.title"))+" ")]),(_vm.comment && _vm.comment.length)?_c('div',[_c('p',{staticClass:"user-comment"},[_vm._v(_vm._s(_vm.comment))])]):_c('div',[_vm._v("-")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }